import { toast } from "@/hooks/use-toast";
import dedent from "dedent-js"

type InviteFriendToEventInput = {
  eventId: string;
  referralCode: string;
}

export const inviteFriendToEvent = (input: InviteFriendToEventInput) => {
  const { eventId, referralCode } = input;
  const message = dedent(`
    Hey! I'm going to this art social with Nimi. Here's a £5 discount for you to join me too!
    ${window.location.origin}/events/${eventId}?referralCode=${referralCode}
  `);

  // Open WhatsApp share
  const shareUrl = `https://wa.me/?text=${encodeURIComponent(message)}`;
  window.open(shareUrl, "_blank");
  
  toast({
    title: "Invite Sent!",
    description: "You and your friends will receive £5 in credits when they join.",
  });
};

export const inviteFriendToSignUp = (
  referralCode: string,
  redirectTo?: string
) => {
  const message = dedent(`
    Hiya! Here is a £5 discount to join Nimi and start exploring new places around London while meeting great people.
    ${
      window.location.origin
    }/auth?action=sign-up&referralCode=${referralCode}${
    redirectTo ? `&redirectTo=${redirectTo}` : ""
  }
  `);

  // Open WhatsApp share
  const shareUrl = `https://wa.me/?text=${encodeURIComponent(message)}`;
  window.open(shareUrl, "_blank");
};

export const buildBringFriendInviteLink = (token: string) =>
  `${window.location.origin}/invite/${token}`;

export const buildBringFriendMessage = (params: {
  token: string;
  eventTitle: string;
  friendName?: string | null;
  expiresAt: string;
}) => {
  const { token, eventTitle, friendName, expiresAt } = params;
  const link = buildBringFriendInviteLink(token);
  const opener = friendName ? `Hey ${friendName}!` : "Hey!";
  const hoursRemaining = Math.max(
    1,
    Math.ceil((new Date(expiresAt).getTime() - Date.now()) / (1000 * 60 * 60)),
  );
  const timeLimit = hoursRemaining < 24
    ? `${hoursRemaining} hour${hoursRemaining === 1 ? "" : "s"}`
    : `${Math.ceil(hoursRemaining / 24)} day${Math.ceil(hoursRemaining / 24) === 1 ? "" : "s"}`;
  return dedent(`
    ${opener} I'm going to "${eventTitle}" with Nimi and I'd love you to join me — your ticket is free! 🎨

    Claim your ticket within ${timeLimit}: ${link}
  `);
};

/**
 * Must be called synchronously inside a click handler — mobile browsers block
 * window.open after an await.
 */
export const shareBringFriendInvite = (params: {
  token: string;
  eventTitle: string;
  friendName?: string | null;
  expiresAt: string;
}) => {
  const message = buildBringFriendMessage(params);
  const shareUrl = `https://wa.me/?text=${encodeURIComponent(message)}`;
  window.open(shareUrl, "_blank");
};